export enum WeddingCakeDecorationStyle {
	Naked = "Naked",
	HalfNaked = "HalfNaked",
	Creamed = "Creamed",
	Birch = "Birch",
	Individual = "Individual",
}
